/*
Toggle elements for AB tests.

On cached page, we can't categorize directly through the server.
We then have to wait for mickey mouse to communicate in each group the user is.
Once done we can show / hide elements regarding data-attributes.

Use:
<div data-abtest="my_test_name" data-abtest-group="my_test_group">
*/
import events from "@/events";

let categories;

export const toggleAbtests = (container = document) => {
  if (!categories) {
    return;
  }
  const nodes = container.querySelectorAll("[data-abtest]");
  for (let i = 0; i < nodes.length; i++) {
    const node = nodes[i];
    const testName = node.dataset.abtest;
    const testGroup = categories[testName] || "control";

    // The element already got toggled
    if (!node.dataset.abtestGroup) {
      continue;
    }

    const nodeGroups = node.dataset.abtestGroup.split(",");

    if (nodeGroups.indexOf(testGroup) >= 0) {
      node.removeAttribute("data-abtest-group");
    } else {
      node.parentNode.removeChild(node);
    }
  }
};

export const eventHandlers = {
  "abtest:ready": testCategories => {
    categories = testCategories;
    toggleAbtests();
    events.emit("abtest:toggled", testCategories);
  }
};
